import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VForm, {
    ref: "parentForm",
    staticClass: "form text-left",
    model: {
      value: _vm.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valid", $$v);
      },
      expression: "form.valid"
    }
  }, [_vm.isLoading ? [_c(VSkeletonLoader, {
    attrs: {
      type: "image"
    }
  }), _c(VSkeletonLoader, {
    attrs: {
      type: "table-row-divider"
    }
  }), _c(VSkeletonLoader, {
    attrs: {
      type: "image"
    }
  }), _c(VSkeletonLoader, {
    attrs: {
      type: "table-heading, table-row-divider@3"
    }
  }), _c(VSkeletonLoader, {
    attrs: {
      type: "image"
    }
  })] : [_c("div", [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true,
      disabled: _vm.isSaving
    },
    on: {
      click: _vm.returnToList
    }
  }, [_c(VIcon, {
    attrs: {
      left: "",
      small: "",
      dark: ""
    }
  }, [_vm._v("fas fa-chevron-left")]), _vm._v(" List ")], 1), !_vm.isCreatingNewPo ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      loading: _vm.isDownloadingPoFile,
      rounded: true
    },
    on: {
      click: function click($event) {
        _vm.isReadOnly ? _vm.downloadPoFile() : _vm.confirmDownloadPoFile();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-download",
    attrs: {
      left: "",
      small: "",
      dark: ""
    }
  }), _vm._v(" PO PDF ")], 1) : _vm._e(), !_vm.isCreatingNewPo ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openAttachedFilesDrawer();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-file-import",
    attrs: {
      left: "",
      small: "",
      dark: ""
    }
  }), _vm._v(" Attached files ")], 1) : _vm._e(), !_vm.isCreatingNewPo ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    class: _vm.isSaving ? "half-disabled" : "",
    attrs: {
      rounded: true,
      disabled: _vm.isSaving
    },
    on: {
      click: _vm.openSendMailModal
    }
  }, [_c(VIcon, {
    attrs: {
      left: "",
      small: "",
      dark: ""
    }
  }, [_vm._v("fas fa-paper-plane")]), _vm._v(" Send mail ")], 1) : _vm._e(), !_vm.isCreatingNewPo && !_vm.isReadOnly && !_vm.hasReceivedItems ? _c(VBtn, {
    staticClass: "dfwa-btn --small danger",
    class: _vm.isSaving ? "half-disabled" : "",
    attrs: {
      rounded: true,
      disabled: _vm.isSaving
    },
    on: {
      click: _vm.cancelPurchaseOrder
    }
  }, [_c(VIcon, {
    attrs: {
      left: "",
      small: "",
      dark: ""
    }
  }, [_vm._v("mdi-cancel")]), _vm._v(" Cancel ")], 1) : _vm._e()], 1), _vm.form.status == _vm.purchaseOrder.status.CANCELLED ? _c("h3", {
    staticClass: "text-center"
  }, [_vm._v("CANCELLED")]) : _vm._e(), _c("div", {
    staticClass: "flex items-start justify-start gap-3 mt-6"
  }, [_c("div", [_vm.form.isAutoGenerate ? _c(VAlert, {
    staticClass: "--small text-xs",
    attrs: {
      dense: "",
      outlined: "",
      type: "info",
      color: "blue",
      text: "",
      icon: "mdi-cog-sync"
    }
  }, [_vm._v(" Automatically generated ")]) : _vm._e()], 1), _vm.form.isAutoGenerate && _vm.form.isSupplierNotifSended !== null && _vm.form.isSupplierNotifSended !== undefined ? _c("div", [_c("div", {
    staticClass: "flex flex-column items-center"
  }, [_vm.form.isSupplierNotifSended ? _c(VAlert, {
    staticClass: "--small text-xs mb-0",
    attrs: {
      dense: "",
      outlined: "",
      type: "success",
      color: "green",
      text: "",
      icon: "mdi-email-check"
    }
  }, [_vm._v(" Supplier notified at " + _vm._s(_vm._f("formatDateTime")(_vm.form.supplierNotifDate)) + " ")]) : [_c(VAlert, {
    staticClass: "--small text-xs mb-0",
    attrs: {
      dense: "",
      outlined: "",
      type: "warning",
      color: "orange darken-2",
      text: "",
      icon: "mdi-email-alert-outline"
    }
  }, [_vm._v(" Supplier not notified yet ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: "",
      loading: _vm.isMarkingAsNotified
    },
    on: {
      click: _vm.markAsNotified
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-check mr-2",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Mark as notified ")], 1)]], 2)]) : _vm._e()]), _c("section", {
    staticClass: "pt-2"
  }, [_c("div", [_c(VCheckbox, {
    attrs: {
      label: "Is allocation",
      disabled: _vm.isReadOnly || _vm.isSaving,
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.isAllocation,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "isAllocation", $$v);
      },
      expression: "form.isAllocation"
    }
  })], 1), _c("div", {
    staticClass: "full"
  }, [!_vm.isReadOnly ? [_c("SupplierSelectComponent", {
    ref: "supplierSelect",
    attrs: {
      suppliers: _vm.suppliers,
      selected: _vm.form.supplierId,
      required: "",
      clearable: "",
      rules: [_vm.rules.mustSelectValue],
      disabled: _vm.isReadOnly || _vm.suppliers.length === 0 || _vm.isSaving
    },
    on: {
      changeSupplier: _vm.changeSupplier,
      fetchSuppliers: _vm.fetchSuppliersWhenItemsUpdated
    }
  }), _vm.isCreatingNewPo && _vm.form.supplierId > 0 ? _c("div", {
    staticClass: "mt-2"
  }, [_vm.checkingPosInProgressSupplier.isPending ? _c("div", {
    staticClass: "flex"
  }, [_c(VProgressCircular, {
    attrs: {
      indeterminate: "",
      size: "16",
      width: "1"
    }
  }), _c("div", {
    staticClass: "text-italic text-smaller ml-1"
  }, [_vm._v("checking POs in progress...")])], 1) : _vm.checkingPosInProgressSupplier.results.length == 0 ? _c("div", {
    staticClass: "flex"
  }, [_c(VAlert, {
    staticClass: "--small success",
    attrs: {
      dense: "",
      outlined: "",
      type: "success",
      color: "green",
      text: ""
    }
  }, [_vm._v(" No PO in progress for this supplier ")])], 1) : _c("div", [_c("div", {
    staticClass: "flex"
  }, [_c(VAlert, {
    staticClass: "--small success",
    attrs: {
      dense: "",
      outlined: "",
      type: "warning",
      color: "orange",
      text: ""
    }
  }, [_vm._v(" " + _vm._s(_vm.checkingPosInProgressSupplier.results.length) + " PO in progress for this supplier. Please verify that you are not duplicating an existing PO ")])], 1), _vm._l(_vm.checkingPosInProgressSupplier.results, function (result) {
    return _c("div", {
      staticClass: "flex text-smaller text-italic mt-1 mb-1 gap-1"
    }, [result.status === _vm.purchaseOrder.status.OPEN ? _c("div", {
      staticClass: "badge --small info"
    }, [_vm._v(" Open ")]) : _vm._e(), result.status === _vm.purchaseOrder.status.DRAFT ? _c("div", {
      staticClass: "badge --small warning"
    }, [_vm._v(" Draft ")]) : _vm._e(), result.receiptStatus === _vm.purchaseOrder.receiptStatus.RECEIVED ? _c("div", {
      staticClass: "badge --small success"
    }, [_vm._v(" Received ")]) : _vm._e(), _c("router-link", {
      staticClass: "router-link",
      attrs: {
        to: _vm.toPoDetails(result.id),
        target: "_blank"
      }
    }, [_c("span", {
      staticClass: "text-bold"
    }, [_vm._v(_vm._s("PO#".concat(result.id)))]), result.reference ? _c("span", [_vm._v(_vm._s(", ".concat(result.reference)))]) : _vm._e(), _c("span", [_vm._v(" " + _vm._s(", ".concat(result.itemsNbBottles, " bottles for ").concat(_vm.formatPrice(result.amount), "\u20AC")) + " ")]), _c("span", {
      staticClass: "text-smaller"
    }, [_vm._v(" created on " + _vm._s(_vm._f("formatDate")(result.creationDate)) + " ")])])], 1);
  })], 2)]) : _vm._e()] : [_c(VTextField, {
    attrs: {
      label: "Supplier",
      disabled: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.supplierName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "supplierName", $$v);
      },
      expression: "form.supplierName"
    }
  })]], 2), !_vm.form.isStoredAtSupplier ? _c("div", {
    staticClass: "full"
  }, [_c("WarehouseSelectComponent", {
    ref: "warehouseSelect",
    staticClass: "half",
    attrs: {
      warehouses: _vm.warehouses,
      selected: _vm.form.warehouseId,
      rules: [_vm.rules.mustSelectValue],
      disabled: _vm.isReadOnly || _vm.warehouses.length === 0 || _vm.isSaving,
      clearable: "",
      label: "Warehouse",
      required: ""
    },
    on: {
      changeWarehouse: _vm.changeWarehouse,
      fetchWarehouses: _vm.fetchWarehousesWhenItemsUpdated
    }
  }), _vm.form.warehouseId ? _c("div", {
    staticClass: "mt-3"
  }, [_c(VCheckbox, {
    attrs: {
      label: "Close/empty every existing direct producer stocks of items bought at receipt ?",
      disabled: _vm.isReadOnly || _vm.isSaving,
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.isCloseConsignmentStocks,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "isCloseConsignmentStocks", $$v);
      },
      expression: "form.isCloseConsignmentStocks"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), false || _vm.form.isStoredAtSupplier ? _c("div", {
    staticClass: "full"
  }, [!_vm.form.isStoredAtSupplier ? _c("div", {
    staticClass: "mb-4"
  }, [_vm._v("or")]) : _vm._e(), _c(VCheckbox, {
    attrs: {
      label: "Items allocations will stay stored in a supplier storage. It will create or fill some direct producer stocks at receipt.",
      disabled: _vm.isReadOnly || _vm.isSaving || _vm.hasFillingOrders,
      "hide-details": "auto"
    },
    on: {
      change: _vm.changeIsStoredAtSupplier
    },
    model: {
      value: _vm.form.isStoredAtSupplier,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "isStoredAtSupplier", $$v);
      },
      expression: "form.isStoredAtSupplier"
    }
  }), _vm.isSupplierWinery && _vm.form.isStoredAtSupplier ? _c(VSelect, {
    staticClass: "mt-2",
    attrs: {
      label: "Supplier storage location",
      disabled: _vm.isReadOnly || _vm.isSaving,
      items: _vm.vineyardStorageAddresses,
      "item-value": "addressId",
      "item-text": "text",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.vineyardAlternateStorageAddressId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "vineyardAlternateStorageAddressId", $$v);
      },
      expression: "form.vineyardAlternateStorageAddressId"
    }
  }) : _vm._e(), _vm.hasFillingOrders ? _c("div", {
    staticClass: "mt-1 text-italic text-smaller"
  }, [_vm._v(" Some items are filling orders. The destination must be a warehouse. ")]) : _vm._e()], 1) : _vm._e(), _vm.form.supplierId && _vm.form.isStoredAtSupplier || _vm.form.supplierId && _vm.form.warehouseId ? [_c("div", {
    staticClass: "mt-2"
  }, [_c("div", {
    staticClass: "title-small"
  }, [_vm._v("Supplier address")]), _c("Address", {
    attrs: {
      baseModel: _vm.currentSupplierAddress,
      listCountries: [_vm.currentSupplierAddress.country],
      listStates: _vm.currentSupplierAddress.state ? [_vm.currentSupplierAddress.state] : null,
      readOnly: true
    }
  })], 1), _c("div", {
    staticClass: "mt-2"
  }, [_c("div", {
    staticClass: "title-small"
  }, [_vm._v("Shipping address")]), _vm.form.warehouseId && !_vm.form.isStoredAtSupplier ? [_c("Address", {
    attrs: {
      baseModel: _vm.currentWarehouseAddress,
      listCountries: [_vm.currentWarehouseAddress.country],
      readOnly: true
    }
  })] : _vm.form.isStoredAtSupplier ? _c("div", {
    staticClass: "text-italic"
  }, [_vm._v("Not Applicable")]) : _vm._e()], 2)] : _vm._e()], 2), _c("section", [_c(VTextField, {
    staticClass: "half required",
    attrs: {
      readonly: "",
      label: "Purchase Order#",
      required: "",
      rules: [_vm.rules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.number,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "number", $$v);
      },
      expression: "form.number"
    }
  }), _c(VTextField, {
    staticClass: "half",
    attrs: {
      label: "Reference#",
      disabled: _vm.isSaving,
      readonly: _vm.isReadOnly,
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.reference,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "reference", $$v);
      },
      expression: "form.reference"
    }
  }), _c(VMenu, {
    attrs: {
      "close-on-content-click": false,
      transition: "scale-transition",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c(VTextField, _vm._g(_vm._b({
          staticClass: "half required",
          attrs: {
            type: "date",
            label: "Date",
            disabled: _vm.isReadOnly || _vm.isSaving,
            readonly: !_vm.isCreatingNewPo,
            required: "",
            rules: [_vm.rules.mustNotBeEmpty],
            "hide-details": "auto"
          },
          model: {
            value: _vm.form.date,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "date", $$v);
            },
            expression: "form.date"
          }
        }, "v-text-field", attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.dateMenu,
      callback: function callback($$v) {
        _vm.dateMenu = $$v;
      },
      expression: "dateMenu"
    }
  }, [_c(VDatePicker, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isCreatingNewPo,
      expression: "isCreatingNewPo"
    }],
    on: {
      input: function input($event) {
        _vm.dateMenu = false;
      }
    },
    model: {
      value: _vm.form.date,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "date", $$v);
      },
      expression: "form.date"
    }
  })], 1), _c(VMenu, {
    attrs: {
      "close-on-content-click": false,
      transition: "scale-transition",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs;
        return [_c(VTextField, _vm._g(_vm._b({
          staticClass: "half required",
          attrs: {
            type: "date",
            label: "Expected delivery date",
            disabled: _vm.isReadOnly || _vm.isSaving,
            required: "",
            rules: [_vm.rules.mustNotBeEmpty],
            "hide-details": "auto"
          },
          model: {
            value: _vm.form.expectedDeliveryDate,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "expectedDeliveryDate", $$v);
            },
            expression: "form.expectedDeliveryDate"
          }
        }, "v-text-field", attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.expectedDateMenu,
      callback: function callback($$v) {
        _vm.expectedDateMenu = $$v;
      },
      expression: "expectedDateMenu"
    }
  }, [_c(VDatePicker, {
    on: {
      input: function input($event) {
        _vm.expectedDateMenu = false;
      }
    },
    model: {
      value: _vm.form.expectedDeliveryDate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "expectedDeliveryDate", $$v);
      },
      expression: "form.expectedDeliveryDate"
    }
  })], 1), _c("div", [_c(VMenu, {
    attrs: {
      "close-on-content-click": false,
      transition: "scale-transition",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref3) {
        var on = _ref3.on,
          attrs = _ref3.attrs;
        return [_c(VTextField, _vm._g(_vm._b({
          attrs: {
            type: "date",
            label: "Actual delivery date",
            disabled: _vm.isDraft || _vm.isCancelled || _vm.isSaving || _vm.isSavingDeliveryDate || _vm.isActualDeliveryDateDisabled,
            "hide-details": "auto"
          },
          model: {
            value: _vm.form.actualDeliveryDate,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "actualDeliveryDate", $$v);
            },
            expression: "form.actualDeliveryDate"
          }
        }, "v-text-field", attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.actualDeliveryDateMenu,
      callback: function callback($$v) {
        _vm.actualDeliveryDateMenu = $$v;
      },
      expression: "actualDeliveryDateMenu"
    }
  }, [_c(VDatePicker, {
    on: {
      input: function input($event) {
        return _vm.changeActualDeliveryDate();
      }
    },
    model: {
      value: _vm.form.actualDeliveryDate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "actualDeliveryDate", $$v);
      },
      expression: "form.actualDeliveryDate"
    }
  })], 1), _vm.hasFillOrderIssues && !_vm.isDraft && !_vm.isCancelled && !_vm.isSaving && _vm.canBypassFillOrders && !_vm.isActualDeliveryDateDisabled ? _c("p", {
    staticClass: "errorLabel --orange text-smaller"
  }, [_vm._v(" Actual delivery date can be set only when all items are fully filled (Bypassing). ")]) : _vm._e(), _vm.hasFillOrderIssues && !_vm.isDraft && !_vm.isCancelled && !_vm.isSaving && !_vm.canBypassFillOrders ? _c("p", {
    staticClass: "errorLabel text-smaller"
  }, [_vm._v(" Actual delivery date can be set only when all items are fully filled. Please ensure all items in the purchase order are properly allocated to orders before setting the delivery date. ")]) : _vm._e()], 1), _c(VMenu, {
    attrs: {
      "close-on-content-click": false,
      transition: "scale-transition",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref4) {
        var on = _ref4.on,
          attrs = _ref4.attrs;
        return [_c(VTextField, _vm._g(_vm._b({
          attrs: {
            type: "date",
            label: "Bill date",
            disabled: _vm.isDraft || _vm.isCancelled || _vm.isSaving || _vm.isSavingBillDate || _vm.isSavingPaymentDate || _vm.isSavingPaymentStatus,
            "hide-details": "auto"
          },
          model: {
            value: _vm.form.billDate,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "billDate", $$v);
            },
            expression: "form.billDate"
          }
        }, "v-text-field", attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.billDateMenu,
      callback: function callback($$v) {
        _vm.billDateMenu = $$v;
      },
      expression: "billDateMenu"
    }
  }, [_c(VDatePicker, {
    on: {
      input: function input($event) {
        return _vm.changeBillDate();
      }
    },
    model: {
      value: _vm.form.billDate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "billDate", $$v);
      },
      expression: "form.billDate"
    }
  })], 1), _c(VSelect, {
    staticClass: "required",
    attrs: {
      items: _vm.listTerms,
      "item-value": "id",
      "item-text": "name",
      disabled: _vm.isCancelled || _vm.isSaving || _vm.isSavingTerms,
      placeholder: "Select a payment terms",
      label: "Payment terms",
      required: "",
      rules: [_vm.rules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    on: {
      change: _vm.termsChanged
    },
    model: {
      value: _vm.form.termsId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "termsId", $$v);
      },
      expression: "form.termsId"
    }
  }), _c(VMenu, {
    attrs: {
      "close-on-content-click": false,
      transition: "scale-transition",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref5) {
        var on = _ref5.on,
          attrs = _ref5.attrs;
        return [_c(VTextField, _vm._g(_vm._b({
          attrs: {
            type: "date",
            label: "Payment date",
            disabled: _vm.isDraft || _vm.isCancelled || _vm.isSaving || _vm.isSavingPaymentDate || _vm.isSavingBillDate || _vm.isSavingPaymentStatus,
            "hide-details": "auto"
          },
          model: {
            value: _vm.form.paymentDate,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "paymentDate", $$v);
            },
            expression: "form.paymentDate"
          }
        }, "v-text-field", attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.paymentDateMenu,
      callback: function callback($$v) {
        _vm.paymentDateMenu = $$v;
      },
      expression: "paymentDateMenu"
    }
  }, [_c(VDatePicker, {
    on: {
      input: function input($event) {
        return _vm.changePaymentDate();
      }
    },
    model: {
      value: _vm.form.paymentDate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "paymentDate", $$v);
      },
      expression: "form.paymentDate"
    }
  })], 1), _c(VSelect, {
    attrs: {
      items: _vm.listPaymentMethods,
      "item-value": "value",
      "item-text": "label",
      disabled: _vm.isDraft || _vm.isCancelled || _vm.isSaving || _vm.isSavingPaymentMethod,
      placeholder: "Select a payment method",
      label: "Payment method",
      "hide-details": "auto"
    },
    on: {
      change: _vm.paymentMethodChanged
    },
    model: {
      value: _vm.form.paymentMethod,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "paymentMethod", $$v);
      },
      expression: "form.paymentMethod"
    }
  })], 1), _c("section", [_c("PurchaseOrderItemsTable", {
    ref: "purchaseOrderItemsTable",
    staticClass: "full",
    attrs: {
      supplierId: _vm.form.supplierId,
      warehouse: _vm.currentWarehouse,
      disabled: _vm.isReadOnly || _vm.isSaving,
      isReadOnly: _vm.isReadOnly,
      items: _vm.form.items,
      options: _vm.itemOptions,
      countries: _vm.implantedMarketCountries,
      isLoadingOptions: _vm.isLoadingWines,
      producerId: _vm.form.producerId,
      loggedUserData: _vm.loggedUserData,
      isStoredAtSupplier: _vm.form.isStoredAtSupplier,
      dbPurchaseOrder: _vm.dbPurchaseOrder
    },
    on: {
      save: _vm.saveItems
    }
  })], 1), _c("section", [_c("div", [_c(VTextarea, {
    ref: "commentaryTextarea",
    attrs: {
      "no-resize": "",
      disabled: _vm.isSavingAndSending || _vm.isSavingDraft || _vm.isSavingComment,
      name: "Your comment",
      label: _vm.isReadOnly ? "Update your comment" : "Write a comment here",
      "hide-details": "auto"
    },
    on: {
      change: _vm.commentChanged
    },
    model: {
      value: _vm.form.commentary,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "commentary", $$v);
      },
      expression: "form.commentary"
    }
  })], 1), _c("div", [_c("div", {
    staticClass: "amount"
  }, [_c("div", [_vm._v("Total")]), _c("div", [_vm._v(_vm._s(_vm.formatPrice(_vm.form.items.reduce(function (acc, x) {
    return acc + +x.amount;
  }, 0))) + " € ex.vat")])]), _vm.isEditing ? _c("div", {
    staticClass: "mt-2"
  }, [!_vm.exportingPdf.isConfiguring ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        _vm.exportingPdf.isConfiguring = true;
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-download mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Export customized PDF ")], 1) : _c("div", {
    staticClass: "p-3"
  }, [_c("div", {
    staticClass: "text-bold"
  }, [_vm._v("Export customized PDF")]), _c("div", {
    staticClass: "text-smaller text-italic"
  }, [_vm._v("Only saved modifcations will be exported")]), _c(VForm, {
    model: {
      value: _vm.exportingPdf.form.isValid,
      callback: function callback($$v) {
        _vm.$set(_vm.exportingPdf.form, "isValid", $$v);
      },
      expression: "exportingPdf.form.isValid"
    }
  }, [_c(VSelect, {
    staticClass: "v-text-field required",
    attrs: {
      items: _vm.currencies,
      disabled: _vm.exportingPdf.isPending,
      "item-value": "id",
      "item-text": "name",
      "hide-details": "auto",
      rules: [_vm.rules.mustSelectValue]
    },
    model: {
      value: _vm.exportingPdf.form.currency,
      callback: function callback($$v) {
        _vm.$set(_vm.exportingPdf.form, "currency", $$v);
      },
      expression: "exportingPdf.form.currency"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Currency rate",
      placeholder: "Let empty to get default automatic up to date rate",
      type: "text",
      required: ""
    },
    on: {
      keypress: _vm.filterDecimal2digitsKey
    },
    model: {
      value: _vm.exportingPdf.form.currencyRate,
      callback: function callback($$v) {
        _vm.$set(_vm.exportingPdf.form, "currencyRate", $$v);
      },
      expression: "exportingPdf.form.currencyRate"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Document main title",
      placeholder: "Let empty to let 'Purchase order' as title. Define 'Invoice' for some cases",
      type: "text",
      required: ""
    },
    model: {
      value: _vm.exportingPdf.form.docTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.exportingPdf.form, "docTitle", $$v);
      },
      expression: "exportingPdf.form.docTitle"
    }
  })], 1), _c("div", {
    staticClass: "flex mt-2"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        _vm.exportingPdf.isConfiguring = false;
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: "",
      disabled: !_vm.exportingPdf.form.isValid,
      loading: _vm.exportingPdf.isPending
    },
    on: {
      click: _vm.exportPdf
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-download mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Export PDF ")], 1)], 1)], 1)], 1) : _vm._e()])]), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c("div", {
    staticClass: "left-buttons-group"
  }), _c("div", {
    staticClass: "right-buttons-group"
  }, [_c("split-button", {
    attrs: {
      mainAction: _vm.splitButtonMainAction,
      dropdownActions: _vm.SplitButtonDropdownActions
    }
  })], 1)])], _vm.sendMailModalShown ? _c("SendMailModal", {
    ref: "SendMailModal",
    attrs: {
      purchaseOrder: _vm.form
    },
    on: {
      closed: _vm.closeSendMailModal
    }
  }) : _vm._e(), _vm.purchaseOrderFormSaveAndSendDrawerShown ? _c("PurchaseOrderFormSaveAndSendDrawer", {
    ref: "saveAndSendDrawer",
    attrs: {
      purchaseOrder: _vm.form,
      isCreatingNewPo: _vm.isCreatingNewPo,
      warehouse: _vm.warehouses.find(function (x) {
        return x.id_warehouse === _vm.form.warehouseId;
      }),
      supplier: _vm.suppliers.find(function (x) {
        return x.id === _vm.form.supplierId;
      })
    },
    on: {
      saved: _vm.saveAndSend,
      closed: _vm.closeSaveAndSendDrawer
    }
  }) : _vm._e(), _c("PurchaseOrderAttachedFilesDrawer", {
    ref: "PurchaseOrderAttachedFilesDrawer",
    attrs: {
      id: _vm.form.id
    }
  }), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };